import { render, staticRenderFns } from "./event-management.vue?vue&type=template&id=5f4f11fc&scoped=true&"
import script from "./event-management.vue?vue&type=script&lang=js&"
export * from "./event-management.vue?vue&type=script&lang=js&"
import style0 from "./event-management.vue?vue&type=style&index=0&id=5f4f11fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f11fc",
  null
  
)

export default component.exports